export const authServer = process.env.VUE_APP_AUTH_URI;
export const apiServerLogistica = process.env.VUE_APP_API_URI_LOGISTICA;
export const apiServerBI = process.env.VUE_APP_API_URI_BI;
export const apiServer = process.env.VUE_APP_API_URI;

// Entorno al que apunta la compilación, sacado de la URL de la API
// (null en producción): se muestra como etiqueta en la cabecera
function calcularEntorno(uri) {
  if (!uri) return null;
  if (/localhost|127\.0\.0\.1/.test(uri)) return "LOCAL";
  const entorno = uri.match(/\.(dev|test|staging)\./);
  return entorno ? entorno[1].toUpperCase() : null;
}
export const entorno = calcularEntorno(apiServer);
export const apiServerV2 = process.env.VUE_APP_API_URI;
export const cexSeguimientoEnvio = process.env.VUE_APP_CEX_SEGUIMIENTO_URI;
export const appVersion = "1.3.3753";
export const apiKeyMaps = "AIzaSyA6HMe4l770I-piy4a9b6FYWybU0v93ORs";
